// retry เฉพาะปัญหาชั่วคราวระดับเครือข่าย/เซิร์ฟเวอร์ — CLIENT_ERROR (4xx) ยิงซ้ำก็ไม่หาย
export const RETRYABLE_PROBLEMS = ['TIMEOUT_ERROR', 'CONNECTION_ERROR', 'NETWORK_ERROR', 'SERVER_ERROR'];

// backoff ถ่างขึ้นตามรอบ (1s, 2s, 4s, ...) คูณสุ่ม 0.5–1.5 เท่า
// กันลูกค้าหลายเครื่องที่ล้มพร้อมกันนัดกันยิงซ้ำพร้อมกันเป็นระลอก
export const jitteredDelay = (attempt, baseDelay) => {
  const backoff = baseDelay * 2 ** (attempt - 1);
  return Math.round(backoff * (0.5 + Math.random()));
};

/**
 * เรียก callApi ซ้ำอัตโนมัติเมื่อผลลัพธ์เป็น error ที่ retry ได้ (ดู RETRYABLE_PROBLEMS)
 * ใช้ได้กับ request ที่อ่านอย่างเดียวเท่านั้น — endpoint ที่สร้าง/แก้ข้อมูลห้ามใช้
 * @param {() => Promise<{ok: boolean, problem: string}>} callApi ฟังก์ชันที่คืน apisauce response
 * @param {{tries?: number, baseDelay?: number, wait?: (ms: number) => Promise}} options
 * @return {Promise<{ok: boolean}>} apisauce response ของครั้งที่สำเร็จ หรือครั้งสุดท้ายที่ล้ม
 */
export const retryApiCall = async (callApi, options = {}) => {
  const {
    tries = 3,
    baseDelay = 1000,
    wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
  } = options;

  for (let attempt = 1; ; attempt++) {
    const response = await callApi();
    if (response.ok || attempt >= tries || !RETRYABLE_PROBLEMS.includes(response.problem)) {
      return response;
    }
    await wait(jitteredDelay(attempt, baseDelay));
  }
};
